import { Box, Stack, Typography } from "@mui/material";
import logoFp from "../../assets/logofp.png";
import { useTranslation } from "react-i18next";

export const OfficialPartner = () => {
	const { t } = useTranslation();
	return (
		<>
			<Box
				sx={{
					width: "100%",
					padding: "10px",
					textAlign: "center",
					backgroundColor: "#147A7A",
				}}
			>
				<Stack
					direction="row"
					spacing={2}
					justifyContent="center"
					alignItems="center"
				>
					<Typography
						sx={{
							color: "#fff",
							opacity: "80%",
							fontSize: window.innerWidth > 600 ? "26px" : "20px",
							fontWeight: "700",
							fontFamily: "Work Sans !important",
						}}
					>
						{t("landing.officialPartner")}
					</Typography>
					<img src={logoFp} style={{ width: "160px" }}></img>
				</Stack>
			</Box>
		</>
	);
};
